import './Sidebar.scss';
import {FC} from 'react';
import InboxIcon from "../../icons/InboxIcon";
import LogoutIcon from "../../icons/LogoutIcon";
import {NavLink} from "react-router-dom";
import {useDispatchEx} from "../../../hooks/redux";
import {asyncLogoutAction} from "../../../redux/slices/auth/authAction";

interface NavLinkClassNames {
    isActive: boolean;
    isPending: boolean;
}
const Sidebar:FC = () => {
    const dispatch = useDispatchEx();
    const getNavLinkClassNames = ({ isActive, isPending }: NavLinkClassNames): string => {
        return isPending ? "pending" : isActive ? "active" : "";
    };
    return (
        /* ДОБАВЛЕН ВНЕШНИЙ КОНТЕЙНЕР-ЗАГЛУШКА */
        <div className="sidebar-placeholder">
            <aside className={'sidebar'}>
                <div className="sidebar__container">
                    <div className="sidebar__header">
                        Admin panel
                    </div>
                    <div className="sidebar__wrapper">

                        <ul className="sidebar__list">
                            <li className="sidebar__list-item">
                                <NavLink className={getNavLinkClassNames} to={'/admin/finance'} title="Финансы">
                                    <InboxIcon/>
                                    <span>Финансы</span>
                                </NavLink>
                            </li>
                            <li className="sidebar__list-item">
                                <NavLink className={getNavLinkClassNames} to={'/admin/users'} title="Пользователи">
                                    <InboxIcon/>
                                    <span>Пользователи</span>
                                </NavLink>
                            </li>
                            <li className="sidebar__list-item">
                                <a onClick={()=>dispatch(asyncLogoutAction())} title="Выйти">
                                    <LogoutIcon/>
                                    <span >Выйти</span>
                                </a>
                            </li>
                        </ul>

                    </div>
                </div>
            </aside>
        </div>
    );
};

export default Sidebar;